import SurveyResultPanel from './surveyResultPanel.container';
export default SurveyResultPanel;